import { render, staticRenderFns } from "./STC.vue?vue&type=template&id=4b41f70c&scoped=true&"
import script from "./STC.vue?vue&type=script&lang=js&"
export * from "./STC.vue?vue&type=script&lang=js&"
import style0 from "./STC.vue?vue&type=style&index=0&id=4b41f70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41f70c",
  null
  
)

export default component.exports